import { UA } from '@colonist/mobile';
export class UIDeviceController {
    static isUserOnTabletApp() {
        if (window.location.hostname.includes('discordsays')) return false;
        if (this.isUserOnMobileAppOrWeb() && window.location.search.includes('tablet=1')) return true;
        const userAgent = navigator.userAgent;
        const tabletUserAgents = [
            UA.IPAD_APP_USER_AGENT,
            UA.TABLET_APP_USER_AGENT
        ];
        return tabletUserAgents.includes(userAgent);
    }
    static isUserOnMobileAppOrWeb() {
        if (window.location.hostname.includes('discordsays')) return false;
        const userAgent = navigator.userAgent;
        const isMobileWebViewAgent = UA.isMobileAppUserAgent(userAgent);
        if (isMobileWebViewAgent) return true;
        const isMobilePath = window.location.pathname.includes('/mobile');
        return isMobilePath;
    }
    static isUserOnIOSApp() {
        if (window.location.hostname.includes('discordsays')) return false;
        const userAgent = navigator.userAgent;
        const iosUserAgents = [
            UA.IPHONE_APP_USER_AGENT,
            UA.IPAD_APP_USER_AGENT
        ];
        return iosUserAgents.includes(userAgent);
    }
    static isUserOnAndroidApp() {
        if (window.location.hostname.includes('discordsays')) return false;
        const userAgent = navigator.userAgent;
        const androidUserAgents = [
            UA.ANDROID_APP_USER_AGENT,
            UA.TABLET_APP_USER_AGENT
        ];
        return androidUserAgents.includes(userAgent);
    }
    static isUserOnDiscordMobile() {
        if (!this.isUserOnDiscord()) return false;
        if (this.isDiscordMountLaunchedAsMobile()) return true;
        return this.isUserOnMobileDevice();
    }
    static isUserOnDiscord() {
        return window.location.hostname.includes('discordsays');
    }
    static isDiscordMountLaunchedAsMobile() {
        return new URLSearchParams(window.location.search).get('platform') === 'mobile';
    }
    static isUserOnFirefox() {
        const userAgent = navigator.userAgent;
        return userAgent.includes('Firefox') || userAgent.includes('FxiOS');
    }
    static isUserOnSafariOrIOS() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isIOS = /ipad|iphone|ipod/.test(userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
        return isIOS || isSafari;
    }
    static isUserOnMobileWebview() {
        if (this._isUserOnMobileWebview != undefined) return this._isUserOnMobileWebview;
        this._isUserOnMobileWebview = this.isUserOnMobileAppOrWeb() || this.isUserOnTabletApp() || this.isUserOnDiscordMobile();
        return this._isUserOnMobileWebview;
    }
    static isCypressTest() {
        if (this._isCypressTest != undefined) return this._isCypressTest;
        this._isCypressTest = typeof window.Cypress !== 'undefined';
        return this._isCypressTest;
    }
    static isUserOnMobileDevice() {
        const userAgent = navigator.userAgent;
        return UA.isMobileDeviceUserAgent(userAgent);
    }
    static isUserOnTabletDevice() {
        const userAgent = navigator.userAgent;
        if (UA.isTabletDeviceUserAgent(userAgent)) return true;
        // iPadOS 13+ reports as Macintosh — detect via touch support
        return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    }
    static isUserOnMobileWebBrowser() {
        if (window.location.hostname.includes('discordsays')) return false;
        if (!this.isUserOnMobileDevice()) return false;
        const userAgent = navigator.userAgent;
        const isMobileWebViewAgent = UA.isMobileAppUserAgent(userAgent);
        return !isMobileWebViewAgent;
    }
    static isUserOnIOSMobileWeb() {
        if (!this.isUserOnMobileWebBrowser()) return false;
        return UA.isIOSDeviceUserAgent(navigator.userAgent);
    }
    static isUserOnAndroidMobileWeb() {
        if (!this.isUserOnMobileWebBrowser()) return false;
        return UA.isAndroidDeviceUserAgent(navigator.userAgent);
    }
    static isUserOnIOSMobileAppOrWeb() {
        return this.isUserOnIOSApp() || this.isUserOnIOSMobileWeb();
    }
    static isUserOnAndroidMobileAppOrWeb() {
        return this.isUserOnAndroidApp() || this.isUserOnAndroidMobileWeb();
    }
    static isUserOnMobileOrTabletWebBrowser() {
        if (this.isUserOnMobileWebBrowser()) return true;
        if (this.isUserOnTabletDevice() && !this.isUserOnTabletApp()) return true;
        return false;
    }
}
UIDeviceController._isUserOnMobileWebview = undefined;
UIDeviceController._isCypressTest = undefined;
